"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const apollo_boost_1 = __importStar(require("apollo-boost"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
const FilterNone_1 = __importDefault(require("@material-ui/icons/FilterNone"));
const DescriptionOutlined_1 = __importDefault(require("@material-ui/icons/DescriptionOutlined"));
const Select_1 = __importDefault(require("../../ui/Select"));
const TextCopyButton_1 = require("../../ui/TextCopyButton");
const client = new apollo_boost_1.default({
    uri: 'api/route/stockManagement',
});
const GET_PRODUCTS_WITH_STOCK = apollo_boost_1.gql `
  query getProductsWithStock($limit: Int, $key: String){
    getProductsWithStock(key: $key, limit: $limit) {
      _id
      key
      centerCost
      stockId
    }
  }
`;
const diffOptions = [
    {
        value: '+',
        label: '增加'
    },
    {
        value: '-',
        label: '減少'
    }
];
function LinkButton(props) {
    const { option } = props;
    console.log(option);
    if (option == null ||
        option.label == "" ||
        option.stockId == null) {
        return (react_1.default.createElement(IconButton_1.default, { disabled: true },
            react_1.default.createElement(DescriptionOutlined_1.default, null)));
    }
    return (react_1.default.createElement("a", { target: "_blank", href: "/#/stockManagement/" + option.stockId },
        react_1.default.createElement(IconButton_1.default, null,
            react_1.default.createElement(DescriptionOutlined_1.default, null))));
}
function InventoryAdjustmentListItemUIView(props) {
    const { required, editable, item, onItemPropertyChanged, onCopyButtonClicked, onDeleteButtonClicked, onMessageSent } = props;
    let deleteButton = null;
    if (onDeleteButtonClicked) {
        deleteButton = (react_1.default.createElement(Grid_1.default, null,
            react_1.default.createElement(IconButton_1.default, { disabled: !editable, onClick: () => onDeleteButtonClicked(item) },
                react_1.default.createElement(Delete_1.default, null))));
    }
    let copyButton = (react_1.default.createElement(Grid_1.default, { item: true },
        react_1.default.createElement(IconButton_1.default, { disabled: !editable, onClick: () => onCopyButtonClicked(item) },
            react_1.default.createElement(FilterNone_1.default, null))));
    return (react_1.default.createElement(ListItem_1.default, { key: item.order },
        react_1.default.createElement(Grid_1.default, { container: true },
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(IconButton_1.default, { disabled: item.product == null || item.product.label == "" },
                    react_1.default.createElement(TextCopyButton_1.TextCopyButton, { text: item.product == null ? "" : item.product.label, onMessageSent: onMessageSent }))),
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(Select_1.default, { required: required, error: editable && required && item.product == null, disabled: !editable, value: item.product, label: "貨品條碼", options: (input) => __awaiter(this, void 0, void 0, function* () {
                        let response = yield client.query({
                            query: GET_PRODUCTS_WITH_STOCK,
                            variables: {
                                key: input,
                                limit: 50,
                            }
                        });
                        return response.data.getProductsWithStock.map((e) => (Object.assign(Object.assign({}, e), { value: e._id, label: e.key })));
                    }), onChange: (e) => {
                        item.product = e;
                        item.unitCost = e.centerCost;
                        onItemPropertyChanged(item);
                    } })),
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(LinkButton, { option: item.product })),
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(Select_1.default, { disabled: !editable, width: 100, value: item.amountNegative == null || !item.amountNegative ? diffOptions[0] : diffOptions[1], label: " ", options: () => __awaiter(this, void 0, void 0, function* () { return diffOptions; }), onChange: (e) => {
                        item.amountNegative = e.value === '-';
                        onItemPropertyChanged(item);
                    } })),
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(TextField_1.default, { required: required, error: editable && required && item.absoluteAmount == null, disabled: !editable, value: item.absoluteAmount == null ? '' : item.absoluteAmount, label: "數量", onChange: (e) => {
                        let value = parseInt(e.target.value);
                        if (isNaN(value)) {
                            value = 0;
                        }
                        item.absoluteAmount = value;
                        onItemPropertyChanged(item);
                    } })),
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(TextField_1.default, { required: required, error: editable && required && item.unitCost == null, disabled: !editable, value: item.unitCost == null ? '' : item.unitCost, label: "認列單位成本", onChange: (e) => {
                        let value = parseInt(e.target.value);
                        if (isNaN(value)) {
                            value = 0;
                        }
                        item.unitCost = value;
                        onItemPropertyChanged(item);
                    } })),
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(TextField_1.default, { disabled: true, label: "認列成本", value: (() => {
                        let amountNegative = item.amountNegative == null ? false : item.amountNegative;
                        let absoluteAmount = item.absoluteAmount == null || isNaN(item.absoluteAmount) ? 0 : item.absoluteAmount;
                        let unitCost = item.unitCost == null || isNaN(item.unitCost) ? 0 : item.unitCost;
                        return (amountNegative ? -1 : 1) * absoluteAmount * unitCost;
                    })() })),
            copyButton,
            deleteButton)));
}
exports.InventoryAdjustmentListItemUIView = InventoryAdjustmentListItemUIView;
